var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStation = function SvgStation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m16 9.517 7 5.347V23H9v-8.136zm-9 4.358L16 7l9 6.875V25H7V13.875",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m13 15 5-.062V17h-3v5l-4.5.063v-2H13z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m21.5 16-3.577 3v-6z"
  })));
};
export { SvgStation as ReactComponent };
export default "data:image/svg+xml,%3csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M16 9.51682L23 14.8643L23 23L9 23L9 14.8643L16 9.51682ZM7 13.8754L16 7L25 13.8754L25 23L25 25L23 25L9 25L7 25L7 23L7 13.8754Z' fill='%234A6067'/%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M13 15L18 14.9375V17H15V22L10.5 22.0625V20.0625H13V15Z' fill='%234A6067'/%3e %3cpath d='M21.5 16L17.9231 19V13L21.5 16Z' fill='%234A6067'/%3e %3c/svg%3e";